import React from "react";

interface Props {
  className?: string;
  onFileReady: (file: FileList) => void;
  id: string;
  children: React.ReactNode;
  multiple?: boolean;
}

const UploadButton: React.FC<Props> = ({
  onFileReady,
  id,
  children,
  multiple,
  className,
}) => {
  const onChangeHandler = (files: FileList | null): void => {
    if (!files) {
      return;
    }

    if (files.length > 0) {
      onFileReady(files);
    }
  };

  return (
    <div className={className}>
      <label htmlFor={id} className="ant-btn ant-btn-primary ant-btn-sm">
        {children}
      </label>
      <input
        id={id}
        type="file"
        accept="text/xml"
        onChange={(e) => onChangeHandler(e.target.files)}
        className="hidden"
        value=""
        multiple={multiple}
      />
    </div>
  );
};

export default UploadButton;
